// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/swipe-cell/index.css
// module id = 451
// module chunks = 32